import { render, staticRenderFns } from "./settings-lists-producttypes.vue?vue&type=template&id=44f236f7&"
import script from "./settings-lists-producttypes.ts?vue&type=script&lang=ts&"
export * from "./settings-lists-producttypes.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports